import { useEffect, useRef } from 'react';

export default function IsMountedWrapper() {
    const isMounted = useRef(true);

    useEffect(() => {
        // Reset on (re)mount so the ref is correct after React StrictMode's dev-only
        // mount -> unmount -> remount cycle (which would otherwise leave it `false`).
        isMounted.current = true;
        return () => {
            isMounted.current = false;
        };
    }, []);

    return isMounted;
}
